import { Invoice } from '#/models/invoice/Invoice';
import { Private } from '#/containers/router/routes/Private';

export class InvoiceHelper {
  private readonly invoice: Invoice;

  constructor(invoice: Invoice) {
    this.invoice = invoice;
  }

  getClientDetailsRoute(): string | null {
    const clientId = this.invoice.client._id;

    switch (this.invoice.clientType) {
      case 'User':
        return Private.TENANTS_DETAILS.to!(clientId);
      case 'OwnerAccount':
        return Private.OWNER_ACCOUNT_DETAILS.to!(clientId);
      case 'Provider':
        return clientId && Private.PROVIDER_DETAILS.to!(clientId);
      case 'Agent':
        return Private.AGENT_DETAILS.to!(clientId);
      default:
        return null;
    }
  }

  getRelatedModelRoute(): string {
    const relatedModelId = this.invoice.relatedModel.id;

    switch (this.invoice.relatedModel.type) {
      case 'Expense':
        return Private.EXPENSES_DETAILS.to!(relatedModelId);
      case 'Income':
        return Private.INCOME_DETAILS.to!(relatedModelId);
    }
  }

  hasCreditNote() {
    return Boolean(this.invoice.creditNoteId);
  }

  isCreditNote() {
    return Boolean(this.invoice.originalInvoiceId);
  }

  isExternal() {
    return this.invoice.isExternal;
  }

  getLinkedInvoiceId() {
    if (this.isCreditNote()) {
      return this.invoice.originalInvoiceId;
    }

    if (this.hasCreditNote()) {
      return this.invoice.creditNoteId;
    }

    return null;
  }

  canCreateRemedy() {
    return this.invoice.externalId && this.invoice.externalStatus === 'requiresInspection';
  }
}
